<template>
  <el-container style="height:100%">
    <div class="login">
      <img src="../../assets/v.png" alt="" class="logopic">
      <div class="login-panel">
        <div class="logo">登录</div>
        <van-cell-group>
          <van-field v-model="username" equired placeholder="用户名" />
          <van-field v-model="password" v-on:keyup.13="toLogin" type="password" placeholder="密码" required />
          <!-- <van-field v-model="nickname" placeholder="昵称" v-show="this.isRegister == true" /> -->
        </van-cell-group>
        <el-checkbox v-model="checked">记住密码</el-checkbox>
        <van-button type="default" @click="login">登录</van-button>
      </div>
      <!-- <p class="tip" v-if="this.isRegister == true">
        已有账号?
        <span class="green" v-on:click="changeType">去登录</span>
      </p>
      <p class="tip" v-else>
        没有账号?
        <span class="green" v-on:click="changeType">注册</span>
      </p> -->
    </div>
  </el-container>
</template>

<script>
  import "./index.less";
  import {
    register,
    login,
    getuserInfo
  } from "../../api/getData";
  import axios from 'axios'
  import {
    mapState,
    mapActions
  } from "vuex";
  export default {
    data() {
      return {
        username: "",
        password: "",
        nickname: "",
        token: "",
        ff: "",
        islogin: false,
        checked: false
      };
    },
    mounted: function () {
      const path = this.isRegister ? "/register" : "/login";

      if (path !== location.pathname) {
        this.$router.push(path);
      }
      if (window.localStorage["loginName"] != null && window.localStorage["loginName"] != undefined) {
        this.username = window.localStorage["loginName"]
        this.password = window.localStorage["loginPwd"]
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    components: {},
    computed: {
      isRegister() {
        return this.$store.state.login.isRegister;
      },
    },
    methods: {
      ...mapActions(["onLogin", "setRegisterFlag", "onRegister"]),
      toLogin(username, password) {
        this.onLogin({
          username: username.toLowerCase(),
          password: password
        });
        localStorage.index = 4
        this.$nextTick(() => {
          this.$router.push('/contact/hz');
          clearInterval(this.ff);
          this.$message({
            type: "success",
            message: '登录成功',
            duration: '1000'
          });
        })
      },
      toRegister() {
        this.onRegister({
          username: this.username.toLowerCase(),
          password: this.password,
          nickname: this.nickname.toLowerCase(),
        });
        this.register(this.username.toLowerCase(), this.password)

      },
      changeType() {
        this.setRegisterFlag(!this.isRegister);
      },
      //注册
      async register(mobile, password) {
        var param = {}
        param.mobile = mobile;
        param.password = password;
        var res = await register(param);
        if (res.code == "0") {

        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      },
      // 登录
      async login(username, password) {
        if (this.islogin == true) {

        } else {
          var param = {}
          param.mobile = this.username;
          param.password = this.password;
          var res = await login(param);
          if (res.code == "0") {
            if (this.checked == true) {
              window.localStorage["loginName"] = this.username
              window.localStorage["loginPwd"] = this.password
            }
            this.islogin = true;
            // 登录成功跳转到默认页
            this.token = res.token
            window.sessionStorage["accessToken"] = res.token
            axios.defaults.headers.common['token'] = res.token
            let self = this
            this.ff = setInterval(function () {
              self.goto(self)
            }, 1000);


          } else {
            this.islogin = false
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        }
      },
      // 获取用户信息
      async getuserInfo() {
        var res = await getuserInfo();
        if (res.code == "0") {
          // this.toLogin(res.data.imId, 123)
          localStorage.setItem("userInfoObj", JSON.stringify(res.data))
          this.toLogin(res.data.imId, res.data.imPassword)
        } else {

        }
      },
      goto(self) {
        if (window.sessionStorage["accessToken"] == '' || window.sessionStorage["accessToken"] == undefined || window
          .sessionStorage["accessToken"] != this.token) {

        } else {

          this.getuserInfo();
        }
      },
    }
  };

</script>

<style lang="less">
  .login {
    .el-checkbox {
      float: left;
      margin-bottom: 24px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue